import styled from 'styled-components';

export const ContactMethodContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 16px 32px;

  :last-of-type {
    padding-bottom: 24px;
  }
`;

export const PrimaryContactMethodContainer = styled(ContactMethodContainer)`
  background-color: ${props => props.theme.colors.background.secondary};
  margin-top: 24px;
`;

export const MxHeadBubble = styled.img.attrs({ alt: '' })`
  border-radius: 50%;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
  height: 48px;
  width: 48px;
`;

export const MxHeadBubbleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -40px;

  ${MxHeadBubble} ~ ${MxHeadBubble} {
    margin-left: -4px;
  }

  ${MxHeadBubble}:nth-of-type(2), ${MxHeadBubble}:nth-last-of-type(2) {
    z-index: 2;
  }

  ${MxHeadBubble}:nth-of-type(3) {
    z-index: 3;
  }
`;

export const SupportTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 30px 16px 16px;
  gap: 16px;
`;
